import { lazy } from 'react';

export const AdministratorSettingsRedirectPage = lazy(
  () => import('./AdministratorSettingsRedirectPage'),
);
